import Stepper from "./Stepper";
import { usePageHeaderBack, usePageContentFullBleed } from "./AppShell";

export default function WizardShell({
  onBack,
  steps,
  currentStep,
  onStepChange,
  canGoToStep,
  summary,
  footer,
  children,
}) {
  usePageHeaderBack(onBack);
  usePageContentFullBleed(true);

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="flex shrink-0 flex-wrap items-center justify-start gap-4 px-[30px] pb-4 pt-6">
        <Stepper
          steps={steps}
          currentStep={currentStep}
          onStepChange={onStepChange}
          canGoToStep={canGoToStep}
        />
      </div>

      <div className="shrink-0 border-t border-(--border-subtle)" />

      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto lg:flex-row lg:overflow-hidden">
        <div className="flex min-w-0 flex-1 flex-col lg:min-h-0 lg:border-r lg:border-(--border-subtle)">
          <div className="flex flex-1 flex-col gap-6 px-[30px] py-6 lg:overflow-y-auto">
            {children}
          </div>
          {footer && (
            <>
              <div className="shrink-0 border-t border-(--border-subtle)" />
              <div className="flex shrink-0 items-center justify-between gap-3 px-[30px] py-4">
                {footer}
              </div>
            </>
          )}
        </div>

        {summary && (
          <aside className="shrink-0 px-[30px] py-6 lg:w-[360px] lg:overflow-y-auto lg:px-6">
            {summary}
          </aside>
        )}
      </div>
    </div>
  );
}
